export default __webpack_public_path__ + "static/media/Genie_Sitting.4ed6b630.svg";